function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable no-unused-expressions */
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import { Form } from 'react-final-form';
import { BaseCard, BaseCardHeader, BaseCardBody, InputField, OverlaySpinner } from '@unite-us/ui';
import { get, isEmpty, isFunction } from 'lodash';
import buildResponses from '@unite-us/surveyjs/dist/components/Renderer/buildResponses';
import ScreeningFormRenderer from '../../../common/ScreeningFormRenderer';
import '@unite-us/surveyjs/src/components/Renderer/surveyjs-styles.scss';
import './ScreeningDetailsCreate.scss';
import FormMenuOptions from '../../../common/FormMenuOptions';
import DeclinedScreenings from '../../DeclinedScreening/DeclinedScreenings';
import { APP_ENVIRONMENT, APP_FLAGS, CALLBACKS, COMPONENTS } from '../../../api/config';
import { createScreen } from '../../../api/api';
import ConsentContent from './ConsentContent';
import { STATUSES, TYPES } from '../../../common/constants';
import { validateDuration, hasSingletonAnswerError } from '../../../common/utils/validateRequiredQuestions';
export function ScreeningDetailsCreate(_ref) {
  var _assessment$decline_r;
  var templateId = _ref.templateId,
    assessment = _ref.assessment,
    editMode = _ref.editMode,
    isFetching = _ref.isFetching,
    onCancel = _ref.onCancel,
    personId = _ref.personId,
    contactFullName = _ref.contactFullName,
    flags = _ref.flags;
  var surveyRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSaving = _useState2[0],
    setIsSaving = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    screeningConsent = _useState4[0],
    setScreeningConsent = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    declineReason = _useState6[0],
    setDeclineReason = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    additionalInfo = _useState8[0],
    setAdditionalInfo = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    step = _useState10[0],
    setStep = _useState10[1];
  var pushInHistory = CALLBACKS.pushInHistory;
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    idOfAnswers = _useState12[0],
    setIdOfAnswers = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    screeningDuration = _useState14[0],
    setScreeningDuration = _useState14[1];
  var handleDurationChange = function handleDurationChange(event) {
    var rawValue = event.target.value.trim();
    if (rawValue === '') {
      setScreeningDuration('');
      return;
    }
    var parsedValue = Math.max(0, Math.min(Number(rawValue), 99));
    setScreeningDuration(parsedValue);
  };
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    error = _useState16[0],
    setError = _useState16[1];
  var Stepper = COMPONENTS.Stepper;
  var isEmr = APP_ENVIRONMENT.isEmr,
    source = APP_ENVIRONMENT.source;
  var notify = CALLBACKS.notify;
  var scrn468ScreeningTimeTrackingEnabled = flags.scrn468ScreeningTimeTrackingEnabled;
  var stepperRef = useRef();
  var steps = [{
    title: 'Consent',
    onStepClick: function onStepClick() {
      return setStep(0);
    }
  }, {
    title: 'Screen',
    onStepClick: function onStepClick() {
      return setStep(1);
    },
    stepDisabled: function stepDisabled(currentStep) {
      return currentStep < 1;
    }
  }];

  // useEffect(() => {
  //   const idsOfSpecificAnswers = [];

  //   assessment.questions.forEach((question) => {
  //     if (question.type === 'select_multiple') {
  //       question.options.forEach((option) => {
  //         if (singletonAnswers.includes(option.value)) {
  //           idsOfSpecificAnswers.push(option.id);
  //         }
  //       });
  //     }
  //   });
  //   setIdOfAnswers(idsOfSpecificAnswers);
  // }, [assessment]);

  var handleOnCancel = function handleOnCancel() {
    if (isFunction(onCancel)) {
      onCancel();
    }
  };
  var handleOnCancelDeclineConsent = function handleOnCancelDeclineConsent() {
    setScreeningConsent(true);
    setStep(0);
  };
  var handleOnDecline = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            notify.success("Your screening for ".concat(contactFullName, " has been declined."));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleOnDecline() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSubmitDeclineReasons = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var _answers$;
      var answers, decline_reason, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsSaving(true);
            answers = Object.keys(data).map(function (key) {
              return {
                question_id: key,
                option_id: data[key]
              };
            });
            decline_reason = (_answers$ = answers[0]) === null || _answers$ === void 0 ? void 0 : _answers$.option_id;
            _context2.next = 5;
            return createScreen({
              templateId: templateId,
              status: STATUSES.DECLINED,
              personId: personId,
              answers: undefined,
              decline_reason: {
                key: decline_reason,
                note: additionalInfo
              },
              source: source
            });
          case 5:
            response = _context2.sent;
            isEmr ? pushInHistory("/patient/".concat(personId, "/screenings/v2/facesheet/").concat(personId, "/submission/").concat(response.id)) : pushInHistory("/screenings/v2/facesheet/".concat(personId, "/submission/").concat(response.id));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onSubmitDeclineReasons(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleOnSubmitDraft = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            onSubmit(STATUSES.DRAFT);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleOnSubmitDraft() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleOnSubmitComplete = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            onSubmit(STATUSES.COMPLETE);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleOnSubmitComplete() {
      return _ref5.apply(this, arguments);
    };
  }();
  var getOptionId = function getOptionId(questionId, valueId) {
    var _assessment$survey_js;
    var question = (_assessment$survey_js = assessment.survey_json.pages[0]) === null || _assessment$survey_js === void 0 ? void 0 : _assessment$survey_js.elements.find(function (q) {
      return q.uuid === questionId;
    });
    if (question.type === TYPES.CHECKBOX || question.type === TYPES.DROPDOWN_MULTISELECT || question.type === TYPES.SELECT_MULTIPLE) {
      return valueId && valueId;
    }
    return valueId && valueId[0];
  };
  var getValue = function getValue(questionId, value) {
    var _assessment$survey_js2;
    var question = (_assessment$survey_js2 = assessment.survey_json.pages[0]) === null || _assessment$survey_js2 === void 0 ? void 0 : _assessment$survey_js2.elements.find(function (q) {
      return q.uuid === questionId;
    });
    if (question.inputType === TYPES.NUMBER) {
      return parseInt(value);
    }
    if (question.inputType === TYPES.DATE) {
      return "".concat(value, "T00:00:00Z");
    }
    return value;
  };
  var onSavingScreeningError = function onSavingScreeningError() {
    notify.error('There was an error saving the screening. Please try again.');
    setIsSaving(false);
  };
  var onSavingScreeningSuccess = function onSavingScreeningSuccess(response) {
    notify.success("Your screening for ".concat(contactFullName, " has been saved."));
    isEmr ? pushInHistory("/patient/".concat(personId, "/screenings/v2/facesheet/").concat(personId, "/submission/").concat(response.id)) : pushInHistory("/screenings/v2/facesheet/".concat(personId, "/submission/").concat(response.id));
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(screenStatus) {
      var _flags$scrn468Screeni, _assessment$survey_js3;
      var survey, responses, answers, shouldValidateDuration, isDurationValid, multiselectId;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            survey = surveyRef.current;
            responses = buildResponses(survey);
            answers = responses.map(function (response) {
              return {
                question_id: response.id,
                option_id: getOptionId(response.id, response.valueId),
                value: getValue(response.id, response.value)
              };
            });
            shouldValidateDuration = (_flags$scrn468Screeni = flags === null || flags === void 0 ? void 0 : flags.scrn468ScreeningTimeTrackingEnabled) !== null && _flags$scrn468Screeni !== void 0 ? _flags$scrn468Screeni : false;
            if (!shouldValidateDuration) {
              isDurationValid = true;
            } else {
              isDurationValid = validateDuration(screenStatus, screeningDuration);
            }
            multiselectId = assessment && ((_assessment$survey_js3 = assessment.survey_json.pages[0].elements.find(function (x) {
              return x.type === 'dropdown-multiselect';
            })) === null || _assessment$survey_js3 === void 0 ? void 0 : _assessment$survey_js3.name);
            surveyRef.current && multiselectId && surveyRef.current.onValidateQuestion.add(function (survey, options) {
              if (options.name === multiselectId) {
                if (hasSingletonAnswerError(options.value)) {
                  options.error = 'Please review your answer'; // change message for the previous one
                  options.error = 'Please review your answer';
                }
              }
            });
            if (!(screenStatus === STATUSES.COMPLETE && survey.hasErrors() || !isDurationValid)) {
              _context5.next = 11;
              break;
            }
            setIsSaving(false);
            _context5.next = 14;
            break;
          case 11:
            setIsSaving(true);
            _context5.next = 14;
            return createScreen({
              templateId: templateId,
              status: screenStatus,
              personId: personId,
              answers: screenStatus !== 'declined' ? answers : undefined,
              source: source,
              duration: screeningDuration,
              onError: onSavingScreeningError,
              onSuccess: onSavingScreeningSuccess
            });
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function onSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var _handleApproveClientAgreement = function handleApproveClientAgreement() {
    stepperRef.setCurrentStep(1);
    setStep(1);
  };
  var _handleDeclineClientAgreement = function handleDeclineClientAgreement() {
    setScreeningConsent(false);
  };
  var handleDeclineReasonChange = function handleDeclineReasonChange(event) {
    setDeclineReason(event);
  };
  var handleAdditionalInfoChange = function handleAdditionalInfoChange(e) {
    setAdditionalInfo(e.target.value);
  };
  var subheaderText = get(assessment, 'notes_text');
  var title = /*#__PURE__*/React.createElement("span", {
    className: "assessment-details-view__header"
  }, get(assessment.survey_json, 'title', ''), subheaderText && /*#__PURE__*/React.createElement("small", {
    className: "assessment-details-view__subheader"
  }, "(".concat(subheaderText, ")")));
  var declineReasonOptions = assessment === null || assessment === void 0 || (_assessment$decline_r = assessment.decline_reason) === null || _assessment$decline_r === void 0 || (_assessment$decline_r = _assessment$decline_r.input) === null || _assessment$decline_r === void 0 ? void 0 : _assessment$decline_r.options;
  var declineReasonValues = declineReasonOptions && Object.keys(declineReasonOptions).map(function (key) {
    var _declineReasonOptions;
    return {
      label: "".concat(get(declineReasonOptions[key], 'primary_text'), ": ").concat(get(declineReasonOptions[key], 'secondary_text', '')),
      value: key,
      order: (_declineReasonOptions = declineReasonOptions[key]) === null || _declineReasonOptions === void 0 ? void 0 : _declineReasonOptions.order
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid assessment-details-view"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-10 offset-sm-1"
  }, Stepper && /*#__PURE__*/React.createElement(Stepper, {
    steps: steps,
    initialStep: step,
    ref: function ref(el) {
      stepperRef = el;
    },
    stepperStyle: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: '#ecf5fd'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-10 offset-sm-1 assessments-show"
  }, /*#__PURE__*/React.createElement(BaseCard, null, /*#__PURE__*/React.createElement(BaseCardHeader, {
    title: title
  }), /*#__PURE__*/React.createElement(BaseCardBody, {
    withPadding: true
  }, /*#__PURE__*/React.createElement(OverlaySpinner, {
    text: "Saving screening...",
    show: isSaving
  }), isFetching && 'Loading...', step === 0 && screeningConsent && !isFetching && !isSaving && /*#__PURE__*/React.createElement(ConsentContent, {
    handleDeclineClientAgreement: function handleDeclineClientAgreement() {
      return _handleDeclineClientAgreement();
    },
    handleApproveClientAgreement: function handleApproveClientAgreement() {
      return _handleApproveClientAgreement();
    }
  }), step === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreeningFormRenderer, {
    editMode: true,
    template: assessment,
    ref: surveyRef,
    idSingletonAnswer: idOfAnswers
  }), scrn468ScreeningTimeTrackingEnabled && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-[0_0_50%]"
  }, /*#__PURE__*/React.createElement(InputField, {
    id: "screeningDuration",
    label: "TIME SPENT ON SCREENINGS (MINUTES)",
    type: "number",
    value: screeningDuration === null ? '' : screeningDuration,
    onChange: handleDurationChange,
    min: "1",
    required: true,
    hint: "Enter the total time (in minutes) you spent directly interacting with the client for this screening."
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "minutes-text"
  }, "Minutes")))), /*#__PURE__*/React.createElement(FormMenuOptions, {
    editMode: editMode,
    isFetching: isFetching,
    isSaving: isSaving,
    handleOnCancel: handleOnCancel,
    handleOnSubmitComplete: handleOnSubmitComplete,
    handleOnSubmitDraft: handleOnSubmitDraft,
    handleOnDecline: handleOnDecline,
    screeningConsent: screeningConsent,
    disableDraftButton: error,
    disabledOnSubmit: !screeningConsent && isEmpty(declineReason) || error
  })), !screeningConsent && /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmitDeclineReasons,
    render: function render(_ref7) {
      var handleSubmit = _ref7.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "add-contact-from-referral"
      }, /*#__PURE__*/React.createElement(DeclinedScreenings, {
        declineReason: declineReason,
        onDeclineReasonChange: handleDeclineReasonChange,
        additionalInfo: additionalInfo,
        onAdditionalInfoChange: handleAdditionalInfoChange,
        options: declineReasonValues && declineReasonValues.sort(function (a, b) {
          return a.order > b.order ? 1 : -1;
        })
      }), /*#__PURE__*/React.createElement(FormMenuOptions, {
        editMode: editMode,
        isFetching: isFetching,
        isSaving: isSaving,
        handleOnCancel: handleOnCancelDeclineConsent,
        handleOnSubmitComplete: handleOnSubmitComplete,
        handleOnSubmitDraft: handleOnSubmitDraft,
        handleOnDecline: handleOnDecline,
        screeningConsent: screeningConsent,
        disableDraftButton: error,
        disabledOnSubmit: !screeningConsent && isEmpty(declineReason) || error
      }));
    }
  }))))));
}
ScreeningDetailsCreate.propTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  templateId: PropTypes.number.isRequired,
  assessment: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired,
  personId: PropTypes.string.isRequired
}, "editMode", PropTypes.bool.isRequired), "isFetching", PropTypes.bool.isRequired), "onCancel", PropTypes.func.isRequired), "contactFullName", PropTypes.string.isRequired), "callbacks", PropTypes.shape({
  notify: PropTypes.shape({
    error: PropTypes.func.isRequired,
    success: PropTypes.func.isRequired,
    warn: PropTypes.func.isRequired
  }).isRequired
}).isRequired), "flags", PropTypes.shape({
  scrn468ScreeningTimeTrackingEnabled: PropTypes.bool
}));
ScreeningDetailsCreate.defaultProps = {
  flags: {}
};
export default ScreeningDetailsCreate;
//# sourceMappingURL=ScreeningDetailsCreate.js.map